import { Component, OnInit } from '@angular/core';
import { MessageBusService, MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';
import { ModalService } from '../../modal.service';

@Component({
  selector: 'shell-without-loan',
  templateUrl: './without-loan.component.html',
})
export class WithoutLoanComponent implements OnInit {
  constructor(
    private microFrontendRouter: MicroFrontendRouter,
    public modalService: ModalService,
    private messageBusService: MessageBusService,
  ) {}

  ngOnInit() {}

  closeModal() {
    this.messageBusService.emit('shell', 'google-tag-manager.event', {
      event: 'button-event',
      eventCategory: 'Prestamo Personal - Derivacion',
      eventAction: 'Derivacion a cuentas',
      eventLabel: 'Derivacion',
    });
    this.messageBusService.emit('shell', 'footer.type', 'DEFAULT');
    this.microFrontendRouter.navigateByUrl(
      '/abrir-cuenta?utm_source=zonadigital&utm_medium=link&utm_campaign=derivacion_pld',
      'abrir-cuenta',
    );
    this.modalService.close();
  }
}
